import { connect } from 'react-redux';

import { getUserName, getWelcomeMessage, getWidgetType, getUserEmail, isClientReady } from 'app/modules';
import replaceUserName from 'lib/replaceUserName.js';
import WelcomeMessage from 'presentation/components/WelcomeMessage';
import { WIDGET_TYPES } from 'enums/configuration';
import { isAlternateBucket } from 'lib/handleBucketLogic';

export const mapStateToProps = state => {
  return {
    email: getUserEmail(state),
    isClientReady: isClientReady(state),
    isDemo: getWidgetType(state) === WIDGET_TYPES.DEMO_SELF_SERVICE,
    isSelfService:
      getWidgetType(state) === WIDGET_TYPES.SELF_SERVICE ||
      isAlternateBucket(state.configuration.onboardingTypeTestBucket),
    welcomeMessage: composeWelcomeMessage(getUserName(state), getWelcomeMessage(state)),
  };
};

function composeWelcomeMessage(userName, welcomeMessage) {
  return replaceUserName(userName, welcomeMessage);
}

const WelcomeMessageContainer = connect(mapStateToProps)(WelcomeMessage);

export default WelcomeMessageContainer;
